<template>
  <div class="flex h-screen overflow-hidden transition ease-in-out duration-300 bg-light-screen-background dark:bg-dark-screen-background">
    <div class="flex flex-col flex-1">
      <main class="flex-1 overflow-y-auto focus:outline-none">
        <div class="relative">
          <div class="flex-col pt-5 pb-16">
            <div class="flex px-0">
              <h1 class="text-3xl transition ease-in-out ml-7 duration-300 text-light-body-text dark:text-dark-body-text">
                {{ $t("Settings") }}
              </h1>
            </div>
            <div class="px-4 sm:px-6 md:px-0">
              <div class="py-6">
                <div class="w-full">
                  <div class="border-b-[1px] border-light-divider-border dark:border-dark-divider-border">
                    <nav class="flex -mb-1 space-x-8 ml-7">
                      <router-link
                        v-for="page in pages"
                        :key="page.page"
                        :to="`/settings/${page.page}`"
                        exact-active-class="text-light-brand-blue dark:text-dark-brand-blue border-b-2"
                        class="flex justify-center items-center whitespace-nowrap py-3 mb-1 px-1 relative transition ease-in-out duration-300 text-sm font-normal select-none text-light-body-text dark:text-common-grey hover:text-black dark:hover:text-gray-300">
                        <div
                          :class="[
                            $route.meta.page_scope_label === page.name ? '' : 'scale-0',
                            'absolute pointer-events-none transition transform ease-in-out duration-side-menu-transition-duration w-full h-[2px] rounded-full bg-light-brand-blue dark:bg-dark-brand-blue -bottom-0.5'
                          ]" />
                        <component
                          :is="page.icon"
                          class="flex-shrink-0 -ml-1 mr-2 h-6 w-6"
                          :class="$route.meta.page_scope_label === page.name ? 'text-blue' : 'text-gray-400 group-hover:text-gray-500'" />
                        <span class="truncate text-md font-medium">
                          {{ $t(page.name) }}
                        </span>
                      </router-link>
                    </nav>
                  </div>
                </div>
                <router-view />
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { NotepadText, UserRoundPen, Info, Building2, User, KeyRound, Palette } from "lucide-vue-next"

export default {
  components: {
    KeyRound,
    Building2,
    NotepadText,
    UserRoundPen,
    Info
  },
  data() {
    return {
      pages: [
        {
          path: "/settings/profile",
          page: "profile",
          name: "Profile",
          icon: UserRoundPen
        },
        {
          path: "/settings/aboutme",
          page: "aboutme",
          name: "More about me",
          icon: Info
        },
        {
          path: "/settings/password",
          page: "password",
          name: "Password",
          icon: KeyRound
        },
        {
          path: "/settings/themes",
          page: "themes",
          name: "Themes",
          icon: Palette
        },
        {
          path: "/settings/my-activities",
          page: "my-activities",
          name: "MyActivities",
          icon: User
        },
        {
          path: "/settings/organization",
          page: "organization",
          name: "Organization",
          icon: Building2
        },
        {
          path: "/settings/organization/billing",
          page: "billing",
          name: "Plans & Billing",
          icon: NotepadText
        }
      ]
    }
  }
}
</script>

<style scoped>
.slide-enter {
  transform: translateX(100%);
}
.slide-enter-to {
  transform: translateX(0);
}
.slide-enter-active {
  position: absolute;
}

.slide-leave {
  transform: translateX(0);
}
.slide-leave-to {
  transform: translateX(-100%);
}

.slide-enter-active,
.slide-leave-active {
  transition: all 250ms ease-in-out;
}
</style>
